module.exports = __webpack_public_path__ + "static/jorisvoorn_0-9064f4a7bd3c6cd16fcd0a67b7e9918a.jpg";